import { Moment } from 'moment';

import { LeagueLocationViewModel, UserGameViewModel, UserTeamViewModel } from '@viewmodels';
import { GameEventType } from '@server/models/Game';
import { BaseUserViewModel } from '@server/services/UserService';

export default class Game implements UserGameViewModel {
  public id: number;
  public awayTeam: UserTeamViewModel;
  public dateMs: number;
  public durationMs: number;
  public homeTeam: UserTeamViewModel;
  public inAbsenceBlackoutWindow: boolean;
  public inSubstitutionRequestBlackoutWindow: boolean;
  public isSubstituteNeeded: boolean;
  public jerseyNumber: number;
  public league: any;
  public location: LeagueLocationViewModel;
  public paymentPending: boolean;
  public permissions: Array<'declareAbsence'>;
  public position: any;
  public present: boolean;
  public results: any;
  public eventType: GameEventType;
  public referee: boolean;
  public kid?: BaseUserViewModel;

  constructor(game: UserGameViewModel) {
    Object.assign(this, game);
  }

  public start(): Moment {
    // FIXME Implement
    return null;
  }
}
